import React from "react";

const DeleteRedIcon = () => {
  return (
    <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="80" height="80" rx="40" fill="#FFD5D5"/>
      <path d="M55.5525 22.7144H47.7747L45.5525 20.4922H34.4414L32.2192 22.7144H24.4414V27.1589H55.5525M26.6636 56.0477C26.6636 57.2265 27.1319 58.3569 27.9654 59.1904C28.7989 60.0239 29.9293 60.4922 31.1081 60.4922H48.8859C50.0646 60.4922 51.1951 60.0239 52.0285 59.1904C52.862 58.3569 53.3303 57.2265 53.3303 56.0477V29.3811H26.6636V56.0477Z" fill="#FF0000"/>
    </svg>

  );
};

export default DeleteRedIcon;
